import { FormControlLabel, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { DataTableQuery } from './DataTable';

export interface IncludeInactiveToggleProps {
  query: DataTableQuery;
  onChange: (next: DataTableQuery) => void;
}

/**
 * Toggle padronizado "Mostrar inativos" para uso no slot `filters` do DataTable.
 * Alterna `query.includeInactive` e reseta para `page: 1` (filtro mudou).
 */
export function IncludeInactiveToggle({
  query,
  onChange,
}: IncludeInactiveToggleProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          checked={Boolean(query.includeInactive)}
          onChange={(_, checked) => onChange({ ...query, page: 1, includeInactive: checked })}
        />
      }
      label={t('components.dataTable.includeInactive')}
    />
  );
}
